import { Injectable } from '@angular/core';
import { ID } from '@common/interfaces/id';
import { RoleNames } from '@common/interfaces/permissions';
import { IProjectScope } from '@common/interfaces/projectScope';
import { IUser } from '@common/interfaces/user';
import { Store, StoreConfig } from '@datorama/akita';
import { v4 } from 'uuid';
import { CLIENT_ID_LOCALSTORAGE_KEY } from '@ep-om/app.service';
import { getRuntimeCacheEpoch } from '@persistence/session-cache';

export interface AuthState {
  clientId: string;
  accessToken: string;
  refreshToken: string;
  userId: ID;
  userAgent: string;
  cacheEpoch: string;
  projectRole: ProjectRoles,
  user: IUser,
}

export type ProjectRoles = { [projectId: string]: RoleNames[] };

export function clientId():string {
  let rv = window.localStorage.getItem(CLIENT_ID_LOCALSTORAGE_KEY);
  if(!rv) {
    rv = v4();
    window.localStorage.setItem(CLIENT_ID_LOCALSTORAGE_KEY,rv);
  } 
  return rv;
}

export function getResettedProperties(state: AuthState) {
  return {
    ...state,
    refreshToken: null,
    accessToken: null,
    projectRole: null,
    userId: null,
    user: null,
  }
}

export function createInitialAuthState(): AuthState {
  // return {
  //   clientId: v4(), userAgent: window.navigator.userAgent
  // } as AuthState;
  let authState = JSON.parse(localStorage.getItem('authStore'))?.auth as AuthState;
  if (!authState) {
    authState = {
      clientId: clientId(), userAgent: window.navigator.userAgent, cacheEpoch: getRuntimeCacheEpoch()
    } as AuthState;
  }
  if (authState && (authState.userAgent !== window.navigator.userAgent || authState.clientId!==clientId())) {
    authState = { clientId: clientId(), userAgent: window.navigator.userAgent, cacheEpoch: getRuntimeCacheEpoch() } as AuthState;
  }
  authState.cacheEpoch = authState.cacheEpoch || getRuntimeCacheEpoch();
  return authState;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({
  name: 'auth',
  resettable: true
})
export class AuthStore extends Store<AuthState> {
  constructor() {
    super(createInitialAuthState());
    if (window.navigator.userAgent !== this.getValue().userAgent) {
      this.update(state => ({... state, userAgent: window.navigator.userAgent}));
    }
  }



  reset(): void {
    this.update(state => getResettedProperties(state));
  }

  updateProjectRolesFromProjectScopes(projectScopes: Pick<IProjectScope, 'projectId' | 'users'>[]): void {
    const state = this.getValue();
    const userId = state.userId || state.user?.id;

    if (!userId) {
      this.update({ projectRole: {} });
      return;
    }

    const projectRole = projectScopes.reduce<ProjectRoles>((acc, projectScope) => {
      const currentUserRole = projectScope?.users?.filter((user) => user.id === '#everyone#' || user.id === userId) || [];
      if (!currentUserRole.length) {
        return acc;
      }

      acc[projectScope.projectId] = currentUserRole.flatMap((role) => role.roles);
      return acc;
    }, {});

    console.log('[PROJECT_SCOPE] new ProjectRoles', projectRole);
    this.update({ projectRole });
  }
}
